import { create } from "zustand";

type AuthUiStore = {
  hasMounted: boolean;
  bootstrapping: boolean;
  setHasMounted: (v: boolean) => void;
  setBootstrapping: (v: boolean) => void;
};

/** Client-only auth UI bootstrap flags (cookie hydrate), not the session profile. */
export const useAuthUiStore = create<AuthUiStore>((set) => ({
  hasMounted: false,
  bootstrapping: true,
  setHasMounted: (hasMounted) => set({ hasMounted }),
  setBootstrapping: (bootstrapping) => set({ bootstrapping }),
}));
